import React from "react";

import { Footer1Props } from "../../props";
import styles from "./footer-variant-04.module.scss";
import FooterStoreAddress from "../../store-address";
import WorkingHoursVariants from "../../working-hours";
import FooterManuVariants from "../../menu-variants";
import FooterSocialIcons from "../../socials";
import PlatformsLogo from "@/components/package-components/editable/logo";

export default function FooterVariant04(props: Footer1Props): JSX.Element {
  return (
    <footer className={styles.container}>
      <div className={styles["container__row"]}>
        <PlatformsLogo
          id={props.id}
          logo={props.logo}
          logoDark={props.logoDark}
          logoWidth={props.logoWidth}
          logoHeight={props.logoHeight}
        />
        <FooterSocialIcons props={props} variant="1" />
      </div>
      <div className={styles["container__row"]}>
        <FooterManuVariants variant="2" props={props} />
        <FooterStoreAddress variant="2" props={props} />
        <WorkingHoursVariants variant="2" props={props} />
      </div>
    </footer>
  );
}
